const umanizzaDataSenzaSecondi = function(dataDisumana) {
    const d = Date.parse(dataDisumana)
    const dt = new Date(d)  
    return `${
            dt.getDate().toString().padStart(2, '0')}/${(dt.getMonth()+1).toString().padStart(2, '0')}/${
            dt.getFullYear().toString().padStart(4, '0')} ${
            dt.getHours().toString().padStart(2, '0')}:${
            dt.getMinutes().toString().padStart(2, '0')}`;
  }

export default umanizzaDataSenzaSecondi;